import { useCallback } from "react";
import { GRAPHQL_ENDPOINT } from "src/constants/endpoints";
import { CREATE_CASH_PAYMENT } from "src/constants/mutations";
import { useAuth } from "src/contexts/auth-provider";
import { useAxiosInterceptor } from "src/hooks/useAxiosInterceptor";

export interface CreateCashPaymentParams {
  customerOrderCorrelationId: string;
  paymentAmountCents: number;
  changeCents: number;
}

export const useCreateCashPayment = () => {
  const { hasRestaurant } = useAuth();
  const { axBe } = useAxiosInterceptor();

  return useCallback(
    async ({
      customerOrderCorrelationId,
      paymentAmountCents,
      changeCents,
    }: CreateCashPaymentParams) => {
      const storeCorrelationId = hasRestaurant?.correlationId;
      if (!storeCorrelationId) {
        throw new Error("No store selected");
      }

      // GraphQL Long / Java Long — must be whole cents (see CreateCashPaymentInput in eatsbitsdesktop)
      const paymentCents = Math.round(Number(paymentAmountCents));
      const changeCentsLong = Math.round(Number(changeCents));

      const { data } = await axBe.post(GRAPHQL_ENDPOINT, {
        query: CREATE_CASH_PAYMENT,
        variables: {
          createCashPaymentInput: {
            storeCorrelationId,
            customerOrderCorrelationId,
            paymentAmountCents: paymentCents,
            changeCents: changeCentsLong,
          },
        },
      });

      const gqlError = data?.errors?.[0];
      if (gqlError?.message) {
        throw new Error(gqlError.message);
      }

      return data?.data?.createCashPayment;
    },
    [axBe, hasRestaurant?.correlationId]
  );
};
